// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"346":"36524e26","886":"b9082f16"}[chunkId] + ".chunk.css";
};